import Login from './views/Login.vue'
import NotFound from './views/404.vue'
// import Ulist from './views/user/Ulist.vue'

import Home from './views/Home.vue'
import Index from './views/index.vue'
import pList from './views/issue/pList.vue'
import cpCompanyList from './views/company/cpcompanylist.vue'

let routes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
    //{ path: '/main', component: Main },
    {
        path: '/',
        component: Index,
        name: 'Home',
        hidden: true
    },
    {
        path: '/issuedApp/',
        redirect:'/issuedApp/index',
        component: Home,
        leaf:true,
        name: '账号管理',
        iconCls: 'el-icon-message',//图标样式class
        children: [
            { path: '/issuedApp/index', component: pList, name: '游戏管理'},
        ]
    },
    {
        path: '/cpCompany',
        redirect:'/cpCompany/index',
        component: Home,
        leaf:true,
        name: 'CP管理',
        iconCls: 'el-icon-message',//图标样式class
        children: [
             { path: '/cpCompany/index', component: cpCompanyList, name: 'CP管理' },
        ]
    },
    
   
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/routes.js